module.exports = __webpack_public_path__ + "img/SketchPngab87abf786d4f786c046a2b6d25aa624ea94fa70afafa263f87de2b29791c614.ba94065b.png";